import { NgModule } from '@angular/core';
import { SideListNewComponent } from './side-list-new.component';
import { SideListItemComponent } from './side-list-item/side-list-item.component';
import { SideListItemHeaderComponent } from './side-list-item-header/side-list-item-header.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [SideListNewComponent, SideListItemComponent, SideListItemHeaderComponent],
    exports: [SideListNewComponent, SideListItemComponent, SideListItemHeaderComponent],
})
export class FiSideListNewModule {}
